export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            关于虫虫
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            了解<strong>虫虫漫画网</strong>的品牌故事与使命
          </p>
        </div>
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 md:gap-10 items-center">
            <div className="flex-1">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                虫虫漫画网创立于2019年，是专注于<strong>免费漫画</strong>在线阅读的专业平台。我们致力于为全球中文漫画爱好者提供最优质、最便捷的阅读服务。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                平台汇聚海量<strong>韩漫</strong>、<strong>日漫</strong>、<strong>国漫</strong>资源，涵盖恋爱、奇幻、悬疑、热血、古风等全品类内容。我们首创<strong>全集漫画下拉式阅读</strong>模式，让读者告别繁琐翻页，沉浸式享受阅读乐趣。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                虫虫漫画网始终秉持"让好漫画触手可及"的理念，坚持免费提供优质内容，每天为数百万读者带来<strong>好看的漫画推荐</strong>和最新更新。我们相信，优秀的漫画作品值得被更多人看到。
              </p>
            </div>
            <div className="flex-shrink-0 w-full lg:w-[280px]">
              <div className="bg-background-50 rounded-2xl p-6 border border-background-200/60">
                <div className="grid grid-cols-2 gap-4 text-center">
                  <div className="p-3">
                    <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">2019</div>
                    <div className="text-xs text-foreground-500 mt-1">创立年份</div>
                  </div>
                  <div className="p-3">
                    <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">10万+</div>
                    <div className="text-xs text-foreground-500 mt-1">漫画作品</div>
                  </div>
                  <div className="p-3">
                    <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">500万+</div>
                    <div className="text-xs text-foreground-500 mt-1">活跃读者</div>
                  </div>
                  <div className="p-3">
                    <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">99.9%</div>
                    <div className="text-xs text-foreground-500 mt-1">服务可用率</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}